import type { FileValue } from './Files.props';
import { Guid } from '../../helpers/Utils';

const createEmptyInput = (): FileValue => ({
  id: Guid.newGuid(),
  url: null,
  name: null,
});

const getDefaultInputs = (inputs: Array<FileValue>) => {
  if (Array.isArray(inputs) && !!inputs?.length) {
    return inputs;
  }
  return [createEmptyInput()];
};

const isExistFileValues = (inputs: Array<FileValue>): boolean => {
  if (!inputs?.length) {
    return false;
  }
  return inputs.some((file) => file?.name && file?.url);
};

const createValueToSend = ({
  isComment = false,
  comment = null,
  inputs,
}: {
  isComment?: boolean;
  comment?: string;
  inputs: Array<FileValue>;
}) => {
  if (isComment) {
    return {
      isComment,
      comment,
      // inputs: []
    };
  }

  return { inputs: inputs.filter((i) => i.id && i?.url) };
};

/**
 * TODO: зарефакторить после добавления package.json в модуль,
 * если хотим делать валидацию не по расширению файла, а по file.type
 *
 * npm i mime-types или схожую либу
 * убрать file.name.split
 * formats.forEach((format) => mime.lookup(format))
 */
const checkValidFormat = (file: File, formats: Array<string>): boolean => {
  let format;

  // !это раскомментить
  // if (file.type.length === 0) {
  //   format = file.name.split('.').pop().toUpperCase();
  //   return formats.includes(format);
  // }

  // !это убрать и зарефакторить, как в описании функции
  format = file.name.split('.').pop().toUpperCase();

  return formats.includes(format);
};

export {
  checkValidFormat,
  getDefaultInputs,
  createValueToSend,
  createEmptyInput,
  isExistFileValues,
};
